module.exports = __webpack_public_path__ + "img/adquirente.e55bde73.jpg";